import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const dialogContentSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  pt: 1,
};

export const fileTileSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  p: 1.5,
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
};

export const mapHintSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
};

export const mapHintWarningSx: SxProps<Theme> = { color: 'warning.dark', mt: '2px' };

export const mapHintInfoSx: SxProps<Theme> = { color: Color.grey600, mt: '2px' };
